import { render, staticRenderFns } from "./SliderQuestionComponent.vue?vue&type=template&id=05a18de2&"
import script from "./SliderQuestionComponent.vue?vue&type=script&lang=js&"
export * from "./SliderQuestionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports